import React, { memo, forwardRef } from 'react';
import cn from 'classnames';
import { Box } from '../box';
import styles from './styles.module.css';
import { useTypography } from '../../hooks';
export const Tag = memo(forwardRef(function Tag(props, ref) {
    const { children, className, variant = 'default', size = 's', ...rest } = props;
    const { className: typographyClassName } = useTypography({
        variant: 'caption1',
        group: 'normal',
        thickness: 'regular',
    });
    return (React.createElement(Box, { ref: ref, className: cn(className, typographyClassName, styles.tag, styles[variant], styles[size]), inline: true, ...rest }, React.Children.toArray(props.children).map((x, i) => typeof x === 'string' ? React.createElement("span", { key: i }, x) : x)));
}));
